import { useApiClient } from '~/api-client';
import { useMutation } from '@tanstack/react-query';
import { EditUnitForm, EditUnitResource } from '@mark43/cad-api';
import { convertHoursMinutesStringToISOString } from '../../common/helpers/utils';

export function useEditUnitFormMutation({ onMutationSuccess }: { onMutationSuccess: () => void }) {
    const apiClient = useApiClient();

    const mutation = useMutation(
        (editUnitForm: EditUnitForm) => {
            const modifiedForm: EditUnitForm = {
                ...editUnitForm,
                shiftStart: convertHoursMinutesStringToISOString(editUnitForm.shiftStart),
                shiftEnd: convertHoursMinutesStringToISOString(editUnitForm.shiftEnd),
            };
            return apiClient
                .request<EditUnitResource.UpdateEditUnit>({
                    method: 'POST',
                    url: 'edit_unit/',
                    data: modifiedForm,
                })
                .then((data) => {
                    return data;
                })
                .catch((err) => {
                    throw err;
                });
        },
        {
            onSuccess() {
                onMutationSuccess();
            },
        }
    );

    return mutation;
}
